import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-services',
    templateUrl: './services.component.html'
})
export class ServicesComponent implements OnInit {
    constructor(
        private _breadcrumbs: BreadcrumbsService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs
            .start({name: 'Mit teszünk?', instructions: ['/mit-teszunk']})
            .add({name: 'Programok', instructions: ['/programok']})
            .add({name: 'Istentiszteletek'});
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/what-we-do/services/services.component.ts